import React from 'react'
import NotAvailable from './NotAvailable'
import SubTitle from './SubTitle'
import CardView from './CardView'
import { ListItem, OrderedList } from '@chakra-ui/react'

const Certifications = ({ Certifications }) => {
    const certificationsIcon = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32"><path fill="currentColor" d="m25 10l1.593 3l3.407.414l-2.5 2.253L28 19l-3-1.875L22 19l.5-3.333l-2.5-2.253L23.5 13l1.5-3zm-3 20h-2v-5a5.006 5.006 0 0 0-5-5H9a5.006 5.006 0 0 0-5 5v5H2v-5a7.008 7.008 0 0 1 7-7h6a7.008 7.008 0 0 1 7 7zM12 4a5 5 0 1 1-5 5a5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7a7 7 0 0 0-7-7z" /></svg>
    return (
        // <>
        //     <SubTitle title="Certifications" titleIcon={certificationsIcon} />
        //     {
        //         Certifications.length === 0 ? <NotAvailable /> :
        //             Certifications.map((obj, index) =>
        //                 <CardView key={index} cardObj={obj} />)
        //     }

        // </>

        <>
            <SubTitle title="Certifications" titleIcon={certificationsIcon} />
            <OrderedList spacing={1} p="4">
                {
                    Certifications.length === 0 ? <NotAvailable /> :
                        Certifications.map((cert, index) => <ListItem key={index}>{cert}</ListItem>)
                }
            </OrderedList>
        </>

    )
}

export default Certifications